<template>
    <div>
        <email-reset-component v-if="type === 'email'"></email-reset-component>
        <phone-reset-component v-else-if="type === 'phone'"></phone-reset-component>

        <div class="row" v-else>
            <div class="col-12">
                <h4 class="tx-color-01 mg-b-5">Reset your password</h4>
                <p class="tx-color-03 mg-b-15">Please select your account type to continue</p>
            </div>
            <div class="col-6">
                <a class="card" href="/password/reset?type=email" @click.prevent="setResetType('email')">
                    <div class="card-body">
                        <img :src="email" class="img-fluid" alt="email">
                    </div>
                    <div class="card-header text-center">
                        <h5 class="card-title">By Email</h5>
                    </div>
                </a>
            </div>
            <div class="col-6">
                <a class="card" href="/password/reset?type=phone" @click.prevent="setResetType('phone')">
                    <div class="card-body">
                        <img :src="phone" class="img-fluid" alt="phone">
                    </div>
                    <div class="card-header text-center">
                        <h5 class="card-title">By Phone</h5>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
	a.card:hover {
		border: 1px solid rgb(244, 145, 41) !important;
	}

	a.card:hover h4 {
		color: #f49129 !important;
	}

	.card-body {
		display: block;
		margin: auto;
	}

	.card-body img.img-fluid {
		height: 60px;
	}

	.card-header {
		border-bottom: none;
	}

	@media (max-width: 425px) {
		.card-body img.img-fluid {
			height: 50px;
		}

		.card-title {
			font-size: 1rem;
		}
	}
</style>


<script>
	import email from '../../../../img/email.svg';
	import phone from '../../../../img/phone.svg';

	export default {
		data() {
			return {
				email,
				phone,
			};
		},
		computed: {
			type() {
				const { type } = this.$route.query;

				if (type) {
					return type;
				}

				return null;
			},
		},
		methods: {
			setResetType(type) {
				this.$router.push({
					path: '',
					query: { type },
				});
			},
		},
	};
</script>
